import React from 'react';

interface SectionProps {
  children: React.ReactNode;
  id?: string;
  /** Adds a subtle tinted background to alternate sections. */
  tint?: boolean;
  className?: string;
  /** Optional aria-label for the landmark. */
  ariaLabel?: string;
}

/**
 * Consistent vertical rhythm + centered container for every page section.
 */
export const Section: React.FC<SectionProps> = ({ children, id, tint = false, className = '', ariaLabel }) => {
  return (
    <section id={id} aria-label={ariaLabel} className={`ds-section ${tint ? 'ds-section--tint' : ''} ${className}`}>
      <div className="ds-container">{children}</div>
    </section>
  );
};

export default Section;
